export const COMMUNITY_NAME = "name";
export const COMMUNITY_REGISTERED_NAME = "registeredName";
export const LANGUAGE = "languageCode";
export const UNITS = "units";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const ZIPCODE = "zipCode";
export const STATE = "state";
export const CITY = "city";
export const GENERAL_PHONE = "generalPhoneNo";
export const EMERGENCY_PHONE = "emergencyPhoneNo";
export const MANAGER_NAME = "communityManagerId";
export const MANAGER_PHONE = "propertyManagerPhone";
export const CONTACT_EMAIL = "contactEmail";
export const WEBSITE = "websiteUrl";
